import React, { useEffect, useState } from "react";
import { Checkbox, Form, message, Row, Col, Skeleton } from "antd";
import { trans, SelectWithSearch, InputText, AddNewButton } from "@comps/components"
import { makeRequest, getErrorProps, makeRequestStateless } from "@utils/helpers";
import { createSingleShift, getRelatedDataReq } from "../requests";
import { Commons, Const } from "../../constants";
import { createSelectList } from '@comps/commonFunctions';
import CreateTimeSlot from "../../timeSlots/components/CreateTimeSlot";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { rosterTooltips } from "../../common/rosterTooltips";
import SingleRosterModal from "../../common/SingleRosterModal";
const langKey = Const["companyRoaster"].lngKey
const formName = "updateReason";

const CreateShift = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [childComponent, setChildComponent] = useState(null);
  const [loading, setloading] = useState(true);
  const [form] = Form.useForm();
  useEffect(() => {
    getRemoteData()
    setFormData()
    // eslint-disable-next-line
  }, []);
  const getRemoteData = () => {
    makeRequestStateless(getRelatedDataReq, null, ongetRelatedDataReq, null);
  }
  const ongetRelatedDataReq = (response) => {
    setTimeSlots(createSelectList(response.time_slots))
    setloading(false)
  }
  const setFormData = () => {
    if (!props) {
      return;
    }
  }
  const onSubmit = (data) => {
    setSaveLoader(true)
    let emp_ids = ''
    props.employments.map((each) => (
      emp_ids += `${each.id},`
    ))
    const payload = {
      shift: {
        date: data.date,
        time_slot_id: data.time_slot_id,
        employment_id: props.employment_id,
        is_full_overtime_shift: data.is_full_overtime_shift || false,
      },
      filters: props.filters,
    }
    makeRequest(setLoader, createSingleShift, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Record Updated");
    props.getAllData(data);
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  const onTimeSlotCreated = (data) => {
    if (data.length) {
      setTimeSlots(createSelectList(data))
      form.setFieldValue('time_slot_id', data[0].id)
    }
    setChildComponent(null);
  }
  return (
    <SingleRosterModal
      title={ <>{ trans(Commons.create) } Roster</> }
      formName={ formName }
      saving={ saveLoader }
      disabled={ props.disabled }
      onCancel={ () => props.onCreated(false) }
    >
      <Skeleton loading={ loading } active>
        <Form
          { ...formLayout }
          form={ form }
          id={ formName }
          name={ formName }
          onFinish={ onSubmit }
          disabled={ props.disabled }
        >
          <Row gutter={ 20 } align="top" className="single-roster-form-row">
            <Col lg={ 11 } md={ 11 } sm={ 24 } xs={ 24 }>
              <Form.Item name="date" rules={ rules.date } label={ fieldLabel('date') }
                className="da-mb-0"
                { ...getErrorProps(errors['name']) } size="small"
                initialValue={ props.date }
              >
                <InputText disabled />
              </Form.Item>
            </Col>

            <Col lg={ 13 } md={ 13 } sm={ 24 } xs={ 24 }>
              <div className="klok-field-action">
                <Form.Item name="time_slot_id" rules={ rules.time_slot_id } label={ fieldLabel('time_slot_id') }
                  className="da-mb-0"
                  { ...getErrorProps(errors['name']) } size="small"
                >
                  <SelectWithSearch
                    options={ timeSlots }
                    placeholder={ trans(`${langKey}.time_slot_id`) }
                  />
                </Form.Item>
                <AddNewButton className="create-roster-add-slot" text="Time Slot" onClick={ () => setChildComponent(<CreateTimeSlot onCreated={ onTimeSlotCreated } />) } />
              </div>
            </Col>

            <Col span={ 24 }>
              <Form.Item name="is_full_overtime_shift" rules={ rules.is_full_overtime_shift } label={ fieldLabel('is_full_overtime_shift') }
                className="da-mb-0 single-roster-checkbox"
                { ...getErrorProps(errors['name']) } size="small"
                valuePropName="checked"
              >
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Skeleton>
      { childComponent }
    </SingleRosterModal>
  )
}

export default CreateShift

const rules = {
  name: [
    { required: true, message: 'Please enter name' },
  ],
  time_slot_id: [
    { required: true, message: trans(`${langKey}.time_slot_id.req`), }
  ]

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}

const fieldLabel = makeFieldLabel(rosterTooltips.shift, { namespace: formName, label: (key) => trans(`${langKey}.${key}`) });
